import styled from 'styled-components';

export const StyledIssuedInvoicesPanel = styled.div`
   display: flex;
   flex-direction: column;
   height: 100%;
`;
StyledIssuedInvoicesPanel.displayName = 'StyledIssuedInvoicesPanel';
